import { FulfillmentType } from "Src/js/types/ProductDelivery";
import { IBaseHttpService } from "Src/js/types/Http";

export enum ResponseType {
	Subscribed,
	InvalidEmail,
}

export interface SuccessResponse {
	type: ResponseType.Subscribed;
}

export interface InvalidEmailResponse {
	type: ResponseType.InvalidEmail;
}

export type Response = SuccessResponse | InvalidEmailResponse;
export type DesiredFulfillmentType = FulfillmentType | 'any';

export interface IBackInStockService {
	subscribe(blainNumber: string, emailAddress: string, fulfillmentType: DesiredFulfillmentType): Promise<Response>;
	unsubscribe(blainNumber: string, emailAddress: string, fulfillmentType: DesiredFulfillmentType): Promise<any>
}

export class FakeBackInStockService implements IBackInStockService {
	constructor(private succeed: boolean = true) {
	}

	async subscribe(blainNumber: string, emailAddress: string, fulfillmentType: DesiredFulfillmentType)
		: Promise<{ type: ResponseType }> {
		await sleep(2000);
		return { type: this.succeed ? ResponseType.Subscribed : ResponseType.InvalidEmail };
	}

	async unsubscribe(): Promise<void> {
		await sleep(2000);
	}
}

export class BackInStockService implements IBackInStockService {
	constructor(private _httpService: IBaseHttpService) { }

	async subscribe(blainNumber: string, emailAddress: string, fulfillmentType: DesiredFulfillmentType): Promise<Response> {
		return this._httpService.post<Response>('/back-in-stock/subscribe', {
			blainNumber,
			emailAddress,
			fulfillmentType,
		});
	}

	async unsubscribe(blainNumber: string, emailAddress: string, fulfillmentType: DesiredFulfillmentType): Promise<Response> {
		// TODO: maybe subscribe should include an entry ID and this should send that alone instead
		return this._httpService.post<Response>('/back-in-stock/unsubscribe', {
			blainNumber,
			emailAddress,
			fulfillmentType,
		});
	}
}

function sleep(timeInMS: number): Promise<void> {
	return new Promise((resolve, _reject) => {
		setTimeout(() => resolve(), timeInMS);
	});
}
